import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { formatFollowUpHistoryLabel, getResetFollowUpState } from '../utils/claimDrawerHelpers';

const ClaimFollowUpPanel = ({
  reclamation,
  followUpDate,
  setFollowUpDate,
  followUpNotes,
  setFollowUpNotes,
  canScheduleFollowUp,
  patchReclamation,
  refreshReclamation,
  setActiveCustomerAction,
  showFollowUpHistory,
  setShowFollowUpHistory,
  followUpHistoryItems,
}) => {
  const handleCancel = () => {
    const nextState = getResetFollowUpState();
    setActiveCustomerAction(nextState.activeCustomerAction);
    setFollowUpDate(nextState.followUpDate);
    setFollowUpNotes(nextState.followUpNotes);
  };

  const handleSchedule = () => {
    if (!canScheduleFollowUp || !patchReclamation) return;
    patchReclamation({
      reclamation: {
        id: reclamation.id,
        activityType: 'followup_set',
        activityDetails: {
          followupAt: followUpDate.toISOString(),
          note: followUpNotes || '',
        },
      },
      callback: () => {
        refreshReclamation();
        const nextState = getResetFollowUpState();
        setActiveCustomerAction(nextState.activeCustomerAction);
        setFollowUpDate(nextState.followUpDate);
        setFollowUpNotes(nextState.followUpNotes);
      },
    });
  };

  return (
    <>
      <div className="drawer-follow-up">
        <div className="drawer-follow-up-title">Schedule Follow-up</div>
        <label className="drawer-follow-up-label" htmlFor="followUpDate">
          Follow-up Date & Time
        </label>
        <DatePicker
          id="followUpDate"
          selected={followUpDate}
          onChange={(date) => setFollowUpDate(date)}
          placeholderText="Select a date and time"
          className="form-control drawer-follow-up-input"
          wrapperClassName="w-100"
          calendarClassName="qt-datepicker"
          popperClassName="qt-datepicker-popper"
          popperPlacement="bottom-start"
          showTimeSelect
          timeIntervals={15}
          timeCaption="Time"
          dateFormat="MM/dd/yyyy h:mm aa"
          shouldCloseOnScroll={false}
          popperModifiers={[]}
          popperContainer={({ children }) =>
            ReactDOM.createPortal(
              <div className="qt-datepicker-portal" style={{ zIndex: 2000, minWidth: 320 }}>
                {children}
              </div>,
              document.body
            )
          }
        />
        <label className="drawer-follow-up-label" htmlFor="followUpNotes">
          Notes (optional)
        </label>
        <textarea
          id="followUpNotes"
          className="form-control drawer-follow-up-input"
          rows={4}
          placeholder="What should be followed up on?"
          value={followUpNotes}
          onChange={(event) => setFollowUpNotes(event.target.value)}
        />
        <div className="drawer-follow-up-actions">
          <button type="button" className="button inverted" onClick={handleCancel}>
            Cancel
          </button>
          <button
            type="button"
            className="button"
            disabled={!canScheduleFollowUp}
            onClick={handleSchedule}
          >
            Schedule
          </button>
        </div>
      </div>
      <div className="drawer-action-history">
        <button
          type="button"
          className="button inverted drawer-action-history-toggle"
          onClick={() => setShowFollowUpHistory((prev) => !prev)}
        >
          {showFollowUpHistory ? 'Hide Follow-up History' : 'Show Follow-up History'}
        </button>
        {showFollowUpHistory &&
          (followUpHistoryItems.length > 0 ? (
            <div className="drawer-action-history-list">
              {followUpHistoryItems.slice(0, 5).map((item, index) => (
                <div key={item.id || item.createdAt || index} className="drawer-list-item">
                  <div style={{ color: '#6b7280', fontSize: '0.85rem' }}>
                    {item.createdAt ? moment(item.createdAt).format('MMM D, YYYY h:mm A') : ''}
                  </div>
                  <div className="drawer-action-history-detail">
                    {formatFollowUpHistoryLabel(item.details?.followupAt)}
                    {item.details?.note && (
                      <div className="drawer-timeline-note">{item.details.note}</div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="drawer-action-history-empty">No follow-up history yet.</div>
          ))}
      </div>
    </>
  );
};

export default ClaimFollowUpPanel;
